
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";

interface GmailIntegrationProps {
  aiStaffId?: string;
  aiStaffName?: string;
}

const GmailIntegration: React.FC<GmailIntegrationProps> = ({ 
  aiStaffId = "1", 
  aiStaffName = "Marketing AI" 
}) => {
  return (
    <Card>
      <CardContent className="pt-6 flex flex-col items-center justify-center space-y-4">
        <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center">
          <Mail className="h-8 w-8 text-blue-500" />
        </div>
        <h3 className="text-lg font-medium">Gmail Integration</h3>
        <p className="text-center text-muted-foreground max-w-md">
          Connect {aiStaffName} to your Gmail account to automate email marketing campaigns.
          This integration is currently in development.
        </p>
        <Button variant="outline" disabled>
          Coming Soon
        </Button>
      </CardContent>
    </Card>
  );
};

export default GmailIntegration;
